/*eslint-disable*/
const isFieldVisible = (field, state) => {
	if (!field?.dependsOn?.length) return true;
	return field.dependsOn.some((condition) =>
		Object.entries(condition).every(
			([key, value]) =>
				String(state?.[key])?.toLowerCase() ===
				String(value)?.toLowerCase()
		)
	);
};

export const validators = {
	requiredFields: ({ step, stepConfig, state }) => {
		const missing = (step?.requiredFields || []).filter((fieldId) => {
			const def = stepConfig?.fields?.find((f) => f.id === fieldId);
			if (def && !isFieldVisible(def, state)) return false;
			const value = state?.[fieldId];
			return (
				value == null ||
				value === '' ||
				(Array.isArray(value) && value.length === 0)
			);
		});
		if (missing.length) {
			const labels = missing.map(
				(fieldId) =>
					stepConfig?.fields?.find((f) => f.id === fieldId)?.label ||
					fieldId
			);
			return {
				valid: false,
				message: `Please fill: ${labels.join(', ')}`,
			};
		}
		return { valid: true };
	},

	tableHasRows: ({ step, tableData }) => {
		if (step?.viewMode) return { valid: true };
		return (tableData?.rows?.length || 0) > 0
			? { valid: true }
			: {
				valid: false,
				message: 'Please add at least one product to the table',
			};
	},
	tableHasQty: ({ step, tableData }) => {
		if (step?.viewMode) return { valid: true };
		const hasQty = (tableData?.rows || []).some((row) =>
			Object.values(row).some(
				(cell) =>
					cell &&
					typeof cell === 'object' &&
					parseFloat(cell.qty) > 0
			));
		return hasQty
			? { valid: true }
			: {
				valid: false,
				message: 'Please enter quantity for at least one product',
			};
	},
};

export const runValidators = (names = [], ctx = {}) => {
	for (const name of names) {
		const validator = validators[name];
		if (!validator) continue;
		const result = validator(ctx) || {};
		if (!result.valid) return result;
	}
	return { valid: true };
};
